(() => {
  if (window.nakisCorporateOptionsBound) return;
  window.nakisCorporateOptionsBound = true;
  const selector = '.nakis-corporate[data-corporate-form]';
  const validatePhone = (input) => {
    const message = !input.value ? input.dataset.phoneMissing :
      (/^05[0-9]{9}$/.test(input.value) ? '' : input.dataset.phoneInvalid);
    input.setCustomValidity(message);
    input.setAttribute('aria-invalid', String(Boolean(message)));
    const error = input.closest('.nakis-corporate__phone-field').querySelector('.nakis-corporate__error');
    error.textContent = message;
    error.hidden = !message;
    return !message;
  };
  document.addEventListener('input', (event) => {
    const input = event.target;
    if (!input.matches(`${selector} .nakis-corporate__phone`)) return;
    let digits = input.value.replace(/[^0-9]/g, '');
    if (digits.startsWith('0090')) digits = digits.slice(4);
    else if (digits.startsWith('90') && digits.length > 11) digits = digits.slice(2);
    if (digits.length === 10 && digits.startsWith('5')) digits = '0' + digits;
    input.value = digits.slice(0, 11);
    input.closest('.nakis-corporate__phone-field').querySelector('[data-corporate-phone-count]').textContent = input.value.length;
    if (input.getAttribute('aria-invalid') === 'true') validatePhone(input);
  });
  const validate = (input) => {
    const file = input.files[0];
    let message = '';
    if (!file && input.required) message = input.dataset.missing;
    else if (file && !/\.(png|jpe?g|webp|pdf)$/i.test(file.name)) message = input.dataset.format;
    else if (file && file.size > 20 * 1024 * 1024) message = input.dataset.size;
    input.setCustomValidity(message);
    input.setAttribute('aria-invalid', String(Boolean(message)));
    const error = input.closest('.nakis-corporate__upload').querySelector('.nakis-corporate__error');
    error.textContent = message;
    error.hidden = !message;
    return !message;
  };
  const update = (input) => {
    const field = input.closest('.nakis-corporate__upload');
    const box = input.closest(selector);
    const file = input.files[0];
    const valid = validate(input);
    const selected = field.querySelector('.nakis-corporate__selected');
    selected.hidden = !file;
    selected.querySelector('span').textContent = file ? file.name : '';
    field.querySelector('[data-corporate-remove]').hidden = !file;
    const preview = field.querySelector('.nakis-corporate__preview');
    if (preview.dataset.objectUrl) URL.revokeObjectURL(preview.dataset.objectUrl);
    delete preview.dataset.objectUrl;
    preview.removeAttribute('src');
    preview.hidden = true;
    if (valid && file && /^image\/(png|jpeg|webp)$/.test(file.type)) {
      preview.dataset.objectUrl = URL.createObjectURL(file);
      preview.src = preview.dataset.objectUrl;
      preview.hidden = false;
    }
    const choice = box.querySelector('[data-corporate-back-choice]');
    const back = box.querySelector('[data-corporate-side="back"] input[type="file"]');
    choice.value = back.files.length ? choice.dataset.separate : choice.dataset.same;
  };
  document.addEventListener('change', (event) => {
    if (event.target.matches(`${selector} .nakis-corporate__phone`)) validatePhone(event.target);
    if (event.target.matches(`${selector} input[type="file"]`)) update(event.target);
  });
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-corporate-remove]');
    if (!button || !button.closest(selector)) return;
    const input = button.closest('.nakis-corporate__upload').querySelector('input[type="file"]');
    input.value = '';
    update(input);
    input.focus();
  });
  document.addEventListener('submit', (event) => {
    const box = Array.from(document.querySelectorAll(selector)).find(item => item.dataset.corporateForm === event.target.getAttribute('id'));
    if (!box) return;
    const phone = box.querySelector('.nakis-corporate__phone');
    let firstInvalid = phone && !validatePhone(phone) ? phone : undefined;
    box.querySelectorAll('input[type="file"]').forEach(input => {
      if (!validate(input) && !firstInvalid) firstInvalid = input;
    });
    if (firstInvalid) {
      event.preventDefault();
      event.stopImmediatePropagation();
      firstInvalid.focus();
      firstInvalid.reportValidity();
    }
  }, true);
})();
